import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  EcoStatusVehicle,
  GetAllVehicle,
  StatusVehicle,
} from "../../../../features/admin/master/vehicle/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const vehicle = useSelector((state) => state.masters.vehicle);

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = vehicle?.current_page) => {
    // await dispatch(Allvehicle());
    await dispatch(
      GetAllVehicle({
        name: name,
        page: page,
        per_page: vehicle?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true; // Success
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      const res = await dispatch(StatusVehicle(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleEcoStatus = async (id) => {
    try {
      const res = await dispatch(EcoStatusVehicle(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    vehicle,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    toggleEcoStatus,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
